<template>
  <el-dialog
    title="添加干部提名"
    :visible.sync="show"
    width="50%"
    @close="onClose"
    :close-on-click-modal="false"
  >
    <div class="column-view">
      <el-form label-position="right" label-width="100px">
        <el-form-item label="所属部门">
          <select-department style="width: 100%;" @onSelectDepartmentChanged="onSelectDepartmentChanged" :departId="dept_id"></select-department>
        </el-form-item>
        <el-form-item label="选择人员">
          <select-employee  style="width: 100%;" @onSelectEmployeeChanged="onSelectEmployeeChanged" :employees="employee_ids"></select-employee>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="()=>{this.show=false}">取 消</el-button>
      <el-button type="primary" @click="onSaveClick()" >保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import selectEmployee from "@/views/setting/departmentManagement/components/selectEmployee";
import selectDepartment from "@/views/setting/promotedManage/components/selectDepartment";
export default {
  name: "CreatePromotedEmployeeDialog",
  components: { selectEmployee,selectDepartment},
  data() {
    return {
      show: false,
      dept_id: '',
      employee_ids:[],
    }
  },
  methods: {
    onSaveClick(){
      if(!this.dept_id){
        return this.$commonUtils.showMessage('请选择部门','error')
      }

      if(!this.employee_ids.length){
        return this.$commonUtils.showMessage('请选择人员','error')
      }

      let request_data={
        dept_id:this.dept_id
      }
      this.employee_ids.forEach((item,index)=>{
        request_data['employee_ids['+index+']']=item;
      })

      this.$prompt('确认保存信息？', '添加干部提名', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        type: 'warning',
        showInput: false,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '保存中...'
            this.http.api('addPromotedPeople', request_data).then(res => {
              if (res.status) {
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '保存'
                done()
                this.show=false;
                this.$commonUtils.showMessage('操作成功','success')
                this.$emit('onRefreshData')
              } else {
                this.$commonUtils.showMessage((res.message) ? (res.message) : '操作失败,请稍候再试', 'error')
                instance.confirmButtonLoading = false
                instance.confirmButtonText = '保存'
              }
            }).catch(() => {
              instance.confirmButtonLoading = false
              instance.confirmButtonText = '保存'
            })
          } else {
            done()
          }
        }
      }).then(res => {
      }).catch(error => {
      })


    },

    onClose() {
      this.dept_id = '';
      this.employee_ids=[];
    },

    showDialog() {
      this.show = true;
    },

    onSelectEmployeeChanged(ids, index) {
      this.employee_ids = ids;
    },
    onSelectDepartmentChanged(id,index){
      this.dept_id=id;
    }
  }
}
</script>

<style scoped>

</style>
